

import barba from '@barba/core';

import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)



export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            setTimeout(() => {
                this.initailTrigger()
            }, 600);
        });
        barba.hooks.after((data) => {
            setTimeout(() => {
                this.initailTrigger()
            }, 600);
        });

    }
    initailTrigger(){
        
        const scrollTriggerY = document.querySelectorAll('[data-scroll-trigger="Y"]')
        if(scrollTriggerY.length > 0){
            scrollTriggerY.forEach(el => {
                gsap.from(el, {
                    opacity:0,
                    y:20,
                    ease:"power2.Out",
                    scrollTrigger: {
                        trigger: el, 
                        start: 'center 80%'
                    }
                })
            })
        }
        const scrollTriggerFade = document.querySelectorAll('[data-scroll-trigger="fade"]')
        if(scrollTriggerFade.length > 0){
            scrollTriggerFade.forEach(el => {
                const delay = (el.getAttribute('data-delay')) ? parseFloat(el.getAttribute('data-delay')) : 0
                gsap.from(el, {
                    opacity:0,
                    delay:delay,
                    ease:"power2.Out",
                    scrollTrigger: {
                        trigger: el, 
                        start: 'center 80%'
                    }
                })
            })
        }
        const scrollTriggerScale = document.querySelectorAll('[data-scroll-trigger="scale"]')
        if(scrollTriggerScale.length > 0){
            scrollTriggerScale.forEach(el => {
                gsap.from(el, {
                    scale:0.9,
                    opacity:0,
                    ease:"power2.Out",
                    scrollTrigger: {
                        trigger: el, 
                        start: 'center 80%'
                    }
                })
            })
        }
        const scrollTriggerCover = document.querySelectorAll('[data-scroll-trigger="cover"]')
        if(scrollTriggerCover.length > 0){
            scrollTriggerCover.forEach(parent => {
                const scrollTriggerImage = parent.querySelector('[data-scroll-trigger="image"]')
                gsap.from(scrollTriggerImage, {
                    opacity:0,
                    scale:1.1,
                    ease:"expo.Out",
                    clearProps:'all',
                    scrollTrigger: {
                        trigger: parent, 
                        start: 'top 80%'
                    }
                })
            })
        }

        const scrollTriggerStrs = document.querySelectorAll('[data-scroll-trigger="str"]')
        if(scrollTriggerStrs.length > 0){
            scrollTriggerStrs.forEach((el)=>{
                el.setAttribute('aria-label',el.textContent)
                let pr_str = el.textContent.split("");
                let str = "";
                pr_str.map( s => {
                    str += "<span class='str__animation' aria-hidden='true'>" + s  + "</span>";
                })
                
                el.innerHTML = str;

                const add_delay = (el.getAttribute('data-delay')) ? parseFloat(el.getAttribute('data-delay')) : 0
                const duration = (el.getAttribute('data-duration')) ? parseFloat(el.getAttribute('data-duration')) : 0.4
                const animation_el = el.querySelectorAll('.str__animation')
                animation_el.forEach((a,i)=>{
                    gsap.from(a, {
                        y:"100%",
                        ease:"power2.Out",
                        clearProps:'all',
                        delay:.07 * i + add_delay,
                        duration:duration,
                        scrollTrigger: {
                            trigger: el, 
                            start: 'top center'
                        }
                    })
                })
            })
        }
    }
}